import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Agenzia } from '../models/agenzia';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class AgenziaService extends ResourcefulService<Agenzia>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Agenzia);
    }
}
